import React, { useEffect, useState } from "react";
import { Table } from "../../components/Table/Table";
import { delete_icon, edit_icon, Search_icon } from "../../assets/img";
import DateRange from "../../components/DateRange/DateRange";
import { URLS } from "../../Services/Constant";
import { deletes, get, patch } from "../../Services/ApiHandler";
import { toast } from "react-toastify";

const StateMmc = ({ setStateEdit, setMappedStates, list = [], setList }) => {
  const [selected, setSelected] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({
    from: "",
    to: "",
    search: "",
  });

  const handleChangeFilter = (key, val) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  const handleDelete = async (data) => {
    let res = await deletes(`${URLS.MMC_PLANS}${selected?.data?.id}/?type=1`);
    if (res?.status === "success") {
      toast.success(res?.message);
      setSelected(false);
      getList();
    }
  };

  const getList = async (sear) => {
    let { from, to, search } = selectedFilters;
    let params = new URLSearchParams({
      type: 1,
    });

    if (from && to) {
      params.append("from_date", from);
      params.append("to_date", to);
    }
    if (search || sear) {
      params.append("search", sear ?? search);
    }
    console.log("params", params);
    let res = await get(`${URLS.MMC_PLANS}?${params}`);
    if (res?.status === "success") {
      setList(res?.data);
      setMappedStates(res?.mapped_states);
    }
  };

  useEffect(() => {
    let { from, to } = selectedFilters;
    if ((from && to) || (!from && !to)) getList();
  }, [selectedFilters.to]);

  const handleEdit = (val) => {
    setStateEdit?.({
      type: "edit",
      data: {
        ...val,
        planType: {
          value: val?.id,
          label: val?.name,
        },
        states: (val?.states ?? []).map((item) => ({
          value: item?.id,
          label: item?.name,
        })),
      },
    });
  };
  const columns = React.useMemo(() => {
    return [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red">{row.index + 1}</p>;
        },
      },
      {
        Header: "Plan Type",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Applied States",
        accessor: "states",
        Cell: ({ value, row }) => {
          let text = (value ?? [])?.map((item, ind) => item?.name).join(", ");
          return (
            <p
              style={{ color: "#0088FF", maxWidth: "150px" }}
              className="d-flex pointer text-decoration-underline text-truncate"
            >
              {text?.length > 20 ? text.slice(0, 20) + "..." : text}
            </p>
          );
        },
      },
      {
        Header: "Plan Amount",
        accessor: "amount",
        Cell: ({ value, row }) => {
          return <p className="">₹ {String(value).padStart(2, 0)}</p>;
        },
      },
      {
        Header: "GST",
        accessor: "gst",
        Cell: ({ value, row }) => {
          return <p className="">{String(value).padStart(2, 0)} %</p>;
        },
      },
      {
        Header: "Total Amount",
        accessor: "total_amount",
        Cell: ({ value, row }) => {
          return <p className="">₹ {value}</p>;
        },
      },
      // {
      //   Header: "Status",
      //   accessor: "status",
      //   Cell: ({ value, row }) => {
      //     return (
      //       <div>
      //         <button

      //           className={`${
      //             value === 1 ? "active-btn" : "deactive-btn"
      //           } border-0 ms-2`}
      //           style={{ fontSize: "12px" }}
      //         >
      //           {value === 1 ? " Active" : "De-active"}
      //         </button>
      //       </div>
      //     );
      //   },
      // },
      {
        Header: "Action",
        accessor: "is_default",
        Cell: ({ value, row }) => (
          <div className="d-flex ac-js">
            <button
              onClick={() => {
                handleEdit(row.original);
              }}
              className="cust-btn"
            >
              <img src={edit_icon} alt="" className="mx-2 edit-btn" />
            </button>

            {/* <button
                  onClick={() =>
                    handleNavigation("view", {
                      data: row.original,
                    })
                  }
                  className="cust-btn"
                >
                  <img src={view_icon} alt="" className="mx-2 edit-btn" />
                </button> */}
            {!value && (
              <button
                onClick={() =>
                  setSelected({ type: "delete", data: row.original })
                }
                className="cust-btn "
              >
                <img src={delete_icon} alt="" className="edit-btn" />
              </button>
            )}
          </div>
        ),
      },
    ];
  }, []);

  return (
    <div className="mt-3">
      <div className="d-flex ac-jb gap-3 ">
        <p
          className="f1 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16"
          style={{ color: "#3C3C4399" }}
        >
          Total Count : {String(list.length).padStart(2, 0)}
        </p>
        <div className="d-flex ac-js gap-3">
          <div className="search-input">
            <input
              onChange={(e) => {
                let val = e.target.value;
                handleChangeFilter("search", val);
                if (!val || val?.length >= 3) getList?.(val);
              }}
              value={selectedFilters.search}
              type="text"
              placeholder="Search"
              style={{ border: "none", width: "150px" }}
            />
            <img src={Search_icon} className="search" />
          </div>

          <DateRange
            setFromDate={(date) => handleChangeFilter("from", date)}
            setToDate={(date) => handleChangeFilter("to", date)}
          />
        </div>
      </div>

      <Table
        columns={columns}
        setPageno={(page) => {}}
        data={list ?? []}
        show={true}
      />

      {selected.type === "delete" && (
        <div className="img-popup-design">
          <div className="img-popup">
            {Boolean(selected?.data?.has_subscription) && (
              <p className="text-danger mb-2 mt-2">
                This Plan has Subcribed by Users.
              </p>
            )}
            <p>Are you sure, want to Delete?</p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => handleDelete(selected?.data)}
                className="add-btn w-40"
              >
                Yes
              </button>
              <button
                onClick={() => setSelected(false)}
                className="back-btn f2 w-40"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StateMmc;
